var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18.001,
    viewBox: "0 0 16 18.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_flag",
    d: "M442.595,1050.1h0a.349.349,0,0,0-.4.054,4.127,4.127,0,0,1-2.7,1.29,4.182,4.182,0,0,1-2.723-1.3c-2.245-1.933-4.451-1.929-7.029-.082-.181.129-.181.129-.149,3.848,0,1.461.025,3.273,0,3.526a.354.354,0,0,0,.577.357,5.279,5.279,0,0,1,3.13-1.115,4.692,4.692,0,0,1,2.125.522,5.242,5.242,0,0,0,2.333.629c4.277,0,4.982-7.064,5.01-7.364A.358.358,0,0,0,442.595,1050.1Zm-14.74-2.244h-.338a.742.742,0,0,0-.744.74h0v16.521a.743.743,0,0,0,.744.74h.338a.743.743,0,0,0,.744-.74h0V1048.6a.742.742,0,0,0-.744-.74Z",
    transform: "translate(-426.772 -1047.861)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_flag.e6271599dc70c90402cb0eac0dedb9fc.svg";